import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage} from "react-intl";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const PresupuestoDetalladoEditModal = (props) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({cantidad: 0, costo: 0, detalle: ''});

	useEffect(() => {
		init();
	}, []);

	const init = () => {
		let copy = JSON.parse(JSON.stringify(data));
        copy.cantidad = props.element.cantidad;
		copy.detalle = props.element.detalle || '';
		switch (props.type) {
			case "presupuestoTarea":
				copy.costo = props.element.precio;
				break;
			case "presupuestoItem":
				copy.costo = props.element.costo;
				break;
			default:
				console.log('default');
		}
		setData(copy);
	};

	const handleMaterialChange = (name, value) => {
		let copy = JSON.parse(JSON.stringify(data));
		if (name === 'detalle') {
			if (value.length <= 60) {
				copy[name] = value;
			}
		} else {
			if ((value && value >= 0) || !value) {
				copy[name] = value;
			}
		}
		setData(copy);
	}

	// Calcular cuántos campos están activos
	const camposActivos = [props.enabledCantidad, props.enabledCosto, props.enabledDetalle].filter(Boolean).length;
	
	// Determinar el ancho máximo según la cantidad de campos activos
	const getMaxWidth = () => {
		if (camposActivos === 1) return '300px';
		if (camposActivos === 2) return '500px';
		return '100%';
	};

	return (
		<>
			<div>
				<div className="text-center mt-2">
					<h3>
						<FormattedMessage id="presupuesto.repuesto" defaultMessage="Repuesto" /> : 
						{props.element.descripcion ? (props.element.descripcion) : (props.element.nombre ? props.element.nombre : '')}
					</h3>
				</div>
				<div className="table-responsive" style={{padding: "15px", display: 'flex', justifyContent: 'center'}}>
					<table
						id="dataTable"
						className="dataTable table nowrap server-side table-hover dataTableMovil"
						style={{maxWidth: getMaxWidth(), width: '100%'}}
					>
						<thead>
							<tr>
								{
									props.enabledCantidad ? 
										<th scope="col" style={{textAlign: 'center'}}>
											<FormattedMessage id="presupuesto.cantidad" defaultMessage="Cantidad" />
										</th>
									: ''
								}
                                {
									props.enabledCosto ? 
                                        <th scope="col" style={{textAlign: 'center'}}>
                                            <FormattedMessage id="Ppresupuesto.precio" defaultMessage="Precio" />
                                        </th>
									: ''
								}
								{
									props.enabledDetalle ? 
										<th scope="col" style={{textAlign: 'center'}}>
											<FormattedMessage id="presupuesto.detalle" defaultMessage="Detalle" />
										</th>
									: ''
								}
							</tr>
						</thead>
						<tbody>
							<tr key={props.element.id}>
								{
									props.enabledCantidad ?
										<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
											<TextField
												id="number"
												type="number"
												onChange={e => handleMaterialChange('cantidad', e.target.value)}
												InputProps={{
													inputProps: { 
														min: 0,
														'data-outline-none': 'true',
														style: { textAlign: 'center' }
													}
												}}
												variant="standard"
												value={data.cantidad}
												fullWidth
											/>
										</td>
									: null
								}
                                {
									props.enabledCosto ?
										<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
											<TextField
                                                id="standard"
                                                type="number"
                                                onChange={e => handleMaterialChange('costo', e.target.value)}
                                                InputProps={{
                                                    inputProps: { 
                                                        min: 0,
														'data-outline-none': 'true',
														style: { textAlign: 'center' }
                                                    }
                                                }}
                                                variant="standard"
                                                value={data.costo}
                                                fullWidth
                                            />
										</td>
									: null
								}
								{
									props.enabledDetalle ?
										<td className="all custom-lineHeight" style={{textAlign: 'center'}}>
											<TextField
												id="detalle"
												type="text"
												onChange={e => handleMaterialChange('detalle', e.target.value)}
												InputProps={{ // <- Para el componente Input de Material-UI
													endAdornment: (
														<InputAdornment position="end" style={{ marginLeft: 'auto' }}>
															<span style={{ fontSize: '0.75rem', color: '#666' }}>
																{data.detalle ? data.detalle.length : 0}/60
															</span>
														</InputAdornment>
													)
												}}
												inputProps={{ // <- Para el <input> HTML nativo
													'data-outline-none': 'true',
													maxLength: 60,
													style: { 
														textAlign: 'center',
														overflow: 'auto',
														whiteSpace: 'nowrap'
													}
												}}
												variant="standard"
												value={data.detalle}
												fullWidth
											/>
										</td>
									: null
								}
							</tr>
						</tbody>
					</table>
				</div>
				<div className="text-center d-flex justify-content-center">
					<button type="button" className="btn btn-primary mr-1" onClick={(e) => props.updateElement(data)}>
						<i className="fa fa-check-circle"></i><FormattedMessage id="presupuesto.guardar" defaultMessage=" Guardar"/>
					</button>
					<button type="button" className="btn btn-danger" onClick={(e) => props.closeModalEdit()}>
						<i className="fa fa-times-circle"></i> { props.intl.formatMessage({ id: 'presupuesto.cancelar', defaultMessage: 'Cancelar' })}
					</button>
				</div>
			</div>
		</>
	);
};

export default PresupuestoDetalladoEditModal;
